import React, { useState } from 'react';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import { Sidebar } from './Sidebar';

/**
 * MobileSidebar - Mobile-responsive sidebar drawer
 * Shows hamburger menu on mobile, opens Sidebar in a Sheet
 */
export function MobileSidebar() {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      {/* Hamburger Menu Button - Only visible on mobile */}
      <SheetTrigger
        className="md:hidden inline-flex h-9 w-9 items-center justify-center rounded-lg text-white hover:bg-white/10 -ml-1"
        aria-label="Open navigation menu"
      >
        {/* Hamburger Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </SheetTrigger>

      {/* Sheet Content with Sidebar */}
      <SheetContent side="left" className="w-64 p-0">
        <Sidebar />
      </SheetContent>
    </Sheet>
  );
}

export default MobileSidebar;
